<template>
  <section
    id="side-bar"
    :class="{
      'flex w-full flex-col border-www-color-neutral-very-light lg:flex-row xl:min-h-full xl:min-w-1/4 xl:max-w-1/4 xl:flex-col xl:border-r min-[1400px]:min-w-1/6 min-[1400px]:max-w-1/6': true,
    }"
    :style="`--customerImageSrc: url(${customerImageSrc})`"
  >
    <!-- Sidebar content here -->
    <div
      :class="{
        'sidebar-bottom hidden h-20 xl:block': true,
      }"
    />
    <div
      :class="{
        'flex flex-col justify-center border-t border-www-color-neutral-very-light py-8 text-center align-middle lg:w-1/3 lg:border-0 xl:w-full xl:max-w-full': true,
      }"
    >
      <img
        :src="userImageSrc"
        alt="background texture"
        :class="{
          'mx-auto h-20 w-20': true,
        }"
      />
      <p
        :class="{
          'text-lg font-bold text-www-color-neutral-medium-dark': true,
        }"
      >
        {{ user ? user.name : leftSideNavData.welcomeGuest }}
      </p>
      <p
        v-if="user"
        :class="{
          'break-words p-3 text-center text-sm text-www-color-neutral-medium': true,
        }"
      >
        {{ user.email }}
      </p>
      <div
        :class="{
          'mx-auto hidden w-1/3 border-b border-www-color-neutral-very-light pt-5 md:block lg:hidden': true,
        }"
      />
    </div>
    <div
      :class="{
        'flex max-h-fit flex-col justify-center border-y border-www-color-neutral-very-light px-11 py-8 align-middle lg:w-1/3 xl:w-full': true,
      }"
    >
      <template v-if="!user">
        <PortableText
          v-if="leftSideNavData.signInMessage?.standardPortableText"
          :class="{
            'sign-in-message max-h-fit text-center font-bold text-www-color-neutral-medium-dark': true,
          }"
          :portable-data="leftSideNavData.signInMessage.standardPortableText"
        />
      </template>
      <div
        :class="{
          invisible: !user,
          'visible flex flex-col': user,
        }"
        data-testid="accountLinks"
      >
        <CustomerSideBarLink
          v-for="(link, index) in filteredLinks"
          :key="index"
          v-bind="link"
        />
      </div>
    </div>

    <div
      :class="{
        'social-wrapper mt-auto hidden h-20 gap-1 pl-4 pt-6 xl:flex': true,
      }"
    >
      <SocialIcon
        v-for="(icon, index) in leftSideNavData.socialMediaIcons"
        :key="index"
        v-bind="icon"
        :class="{ 'max-h-8 max-w-8 transition duration-300 hover:brightness-75': true }"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import CustomerSideBarLink from '~/components/Atmos/CustomerSideBarLink/CustomerSideBarLink.vue';
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import SocialIcon from '~/components/Atmos/SocialIcon/SocialIcon.vue';
import type { CustomerHomeQueryResult } from '~/sanity/types';
type LeftSideNavProps = {
  leftSideNavData: NonNullable<CustomerHomeQueryResult>['leftSideNav'];
};
const props = defineProps<LeftSideNavProps>();
const { user } = useCrossSession();
const { isPaid } = usePersonalization();

const filteredLinks = computed(() => {
  if (!props.leftSideNavData.content) return [];
  return props.leftSideNavData.content.filter((item) => {
    return !item.isPaidOnly || isPaid.value;
  });
});
const { $staticImages } = useNuxtApp();
const userImageSrc = $staticImages['default-user'];
const customerImageSrc = $staticImages['customer-home-texture'];
</script>

<style>
.sidebar-bottom,
.social-wrapper {
  background-image: var(--customerImageSrc);
}
</style>
